// This file was automatically generated from appanalytics.reports.muPopulation.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appanalytics.reports.muPopulation');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appanalytics.reports.navPanel');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation.filters = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h3 class="padb5 el8BlueBold">Find Patients</h3><div class="el8FieldSection clearfix w100"><div class="el8Col4"><p class="el8NormalLabel el8Wrap">who are <strong>patients of</strong>:</p></div><div class="el8Col8"><div class="el8Wrap"><select name="physician" class="w100"><option value="">Entire Practice</option>');
  var pList567 = opt_data.physicianUsers;
  var pListLen567 = pList567.length;
  for (var pIndex567 = 0; pIndex567 < pListLen567; pIndex567++) {
    var pData567 = pList567[pIndex567];
    output.append('<option value="', soy.$$escapeHtml(pData567.staffId), '">', soy.$$escapeHtml(pData567.name), '</option>');
  }
  output.append('</select></div></div></div><div class="el8FieldSection clearfix w100"><div class="el8Col4"><div class="el8Wrap"><select name="lastSeenFilter" class="w100"><option value="">All Patients</option><option value="SINCE">Seen Since</option><option value="NOT_SINCE">Not Seen Since</option></select></div></div><div class="el8Col8"><div class="filter-days-since el8Wrap"><select name="filterDaysSince" class="w100"><option value="">all time</option><option value="365">1 year</option><option value="730">2 years</option><option value="1095">3 years</option><option value="1460">4 years</option><option value="1825">5 years</option><option value="0">custom</option></select><div class="custom-start-date el8TextareaWrap el8DatePickerWrap" style="display: none"><input type="text" class="el8DatePicker" name="startDate" /></div><div class="custom-end-date el8TextareaWrap el8DatePickerWrap" style="display: none"><input type="text" class="el8DatePicker" name="endDate" /></div></div></div></div><div class="relative"><h5 class="el8LightSectionHeader">Demographics</h5><div class="el8FieldSectionOverflow clearfix w100"><div class="el8Col4"><p class="el8NormalLabel el8Wrap">between the <strong>ages</strong> of:</p></div><div class="el8Col8"><div class="el8TextareaWrap el8InlineBlock w30 ml10"><input type="text" class="w100" name="minAge" /></div><span class="el8AppText el8InlineBlock">and</span><div class="el8TextareaWrap el8InlineBlock w30"><input type="text" class="w100" name="maxAge" /></div></div></div><div class="el8FieldSectionOverflow clearfix w100"><div class="el8Col4"><p class="el8NormalLabel el8Wrap">and <strong>gender</strong> is:</p></div><div class="el8Col8"><div class="el8Wrap"><select name="gender" class="w100"><option value="">Any gender</option><option value="F">Female</option><option value="M">Male</option><option value="N">Unspecified</option></select></div></div></div><!-- Contents of demographics section that will hide/show --><div class="mu-demog-extras"><div class="el8FieldSectionOverflow clearfix w100"><div class="el8Col4"><p class="el8NormalLabel el8Wrap">and <strong>race</strong> is:</p></div><div class="el8Col8"><div class="el8Wrap"><select name="race" class="w100"><option value="">Any race</option>');
  var rList575 = opt_data.races;
  var rListLen575 = rList575.length;
  for (var rIndex575 = 0; rIndex575 < rListLen575; rIndex575++) {
    var rData575 = rList575[rIndex575];
    output.append('<option value="', soy.$$escapeHtml(rData575[0]), '">', soy.$$escapeHtml(rData575[1]), '</option>');
  }
  output.append('</select></div></div></div><div class="el8FieldSectionOverflow clearfix w100"><div class="el8Col4"><p class="el8NormalLabel el8Wrap">and <strong>ethnicity</strong> is:</p></div><div class="el8Col8"><div class="el8Wrap"><select name="ethnicity" class="w100"><option value="">Any ethnicity</option>\\');
  var eList583 = opt_data.ethnicities;
  var eListLen583 = eList583.length;
  for (var eIndex583 = 0; eIndex583 < eListLen583; eIndex583++) {
    var eData583 = eList583[eIndex583];
    output.append('<option value="', soy.$$escapeHtml(eData583[0]), '">', soy.$$escapeHtml(eData583[1]), '</option>');
  }
  output.append('</select></div></div></div><div class="el8FieldSection clearfix w100"><div class="el8Col4"><p class="el8NormalLabel el8Wrap">and <strong>preferred language</strong> is:</p></div><div class="el8Col8"><div class="el8Wrap"><select name="prefLanguage" class="w100"><option value="">Any language</option>');
  var lList591 = opt_data.languages;
  var lListLen591 = lList591.length;
  for (var lIndex591 = 0; lIndex591 < lListLen591; lIndex591++) {
    var lData591 = lList591[lIndex591];
    output.append('<option value="', soy.$$escapeHtml(lData591.name), '">', soy.$$escapeHtml(lData591.name), ' (', soy.$$escapeHtml(lData591.abbreviation), ')</option>');
  }
  output.append('</select></div></div></div><div class="el8FieldSection clearfix w100"><div class="el8Col4"><p class="el8NormalLabel el8Wrap">and <strong>preferred contact method</strong> is:</p></div><div class="el8Col8"><div class="el8Wrap"><select name="prefContactMethod" class="w100"><option value="">Any contact method</option><option value="sms">SMS (Text Message)</option><option value="email">E-mail</option><option value="phone">Phone</option><option value="passport">Patient Passport</option></select></div></div></div></div><!-- End contents of demographics section that will hide/show --><p class="el8AlignCenter"><a class="mu-demog-extras-trigger"></a></a></div>', (el8Globals.FEATURES.PatientPortal) ? '<div class="mv10"><h5 class="el8LightSectionHeader">Patient Passport Status</h5><div class="w100"><label class="el8CheckMark"><input class="passport-checkbox" type="checkbox" name="USED"></input>Registered user</label><label class="el8CheckMark"><input class="passport-checkbox" type="checkbox" name="INVITED"></input>Invited, not registered</label><label class="el8CheckMark"><input class="passport-checkbox" type="checkbox" name="NOT_INVITED"></input>Not invited</label></div></div>' : '', (el8Globals.FEATURES.BiDiLabs) ? '<div class="mv10"><h5 class="el8LightSectionHeader">Order Status</h5><div class="w100"><label class="el8CheckMark"><input class="orderstatus-checkbox" type="checkbox" name="orderstatus-outstanding"></input>Outstanding</label><label class="el8CheckMark"><input class="orderstatus-checkbox" type="checkbox" name="orderstatus-cancelled"></input>Cancelled</label><label class="el8CheckMark"><input class="orderstatus-checkbox" type="checkbox" name="orderstatus-resolved"></input>Fulfilled</label></div></div>' : '', '<div class="relative mt5"><h5 class="el8LightSectionHeader">Clinical Data</h5><p class="padl5 padb10">and<select class="w13 mh5 el8StandardFontSize" name="logicalOperator"><option value="AND" selected>all</option><option value="OR">any</option></select>of the following are true:</p><div class="el8FieldSection clearfix w100 mv5"><p class=""><strong>Most Recent Lab Results</strong>:</p><div id="mu-population-lab-tests-list" class="el8ListStyleNone"></div><div class="el8AlignRight"><button type="button" tabindex="" class="add-entry-trigger el8FormLink" data-group="labs">+ Add Another</button></div></div>', (opt_data.hccScoringEnabled) ? '<div class="el8FieldSection clearfix w100 mv5"><p class="mb5"><strong>Risk Score</strong>:</p><div class="el8Col8"><span class="el8AppText el8InlineBlock">Between</span><div class="el8TextareaWrap el8InlineBlock w30 ml10"><input type="text" class="w100" name="minHcc" /></div><span class="el8AppText el8InlineBlock">and</span><div class="el8TextareaWrap el8InlineBlock w30"><input type="text" class="w100" name="maxHcc" /></div></div></div>' : '', '<div class="el8FieldSection clearfix w100 mv5"><p class="mb5"><strong>Active Problems</strong>:</p><ol id="add-problems-list" class="el8ClearBPM"></ol><div class="el8AlignRight"><button type="button" tabindex="" class="add-entry-trigger el8FormLink" data-group="problems">+ Add Another</button></div></div><div class="el8FieldSection clearfix w100 mv5"><p class="mb5"><strong>Active Medications</strong>:</p><ol id="add-medications-list" class="el8ClearBPM"></ol><div class="el8AlignRight"><button type="button" tabindex="" class="add-entry-trigger el8FormLink" data-group="medications">+ Add Another</button></div></div><div class="el8FieldSection clearfix w100 mv5"><p class="mb5"><strong>Active Allergies</strong>:</p><ol id="add-allergies-list" class="el8ClearBPM"></ol><div class="el8AlignRight"><button type="button" tabindex="" class="add-entry-trigger el8FormLink" data-group="allergies">+ Add Another</button></div></div><div class="el8FieldSection clearfix w100 mv5"><p class="mb5"><strong>Vaccinations</strong>:</p><ol id="add-vaccines-list" class="el8ClearBPM"></ol><div class="el8AlignRight"><button type="button" tabindex="" class="add-entry-trigger el8FormLink" data-group="vaccines">+ Add Another</button></div></div><div class="el8FieldSection clearfix w100 mv5"><p class="mb5"><strong>Patient Tags</strong>:</p><ol id="add-tags-list" class="el8ClearBPM"></ol><div class="el8AlignRight"><button type="button" tabindex="" class="add-entry-trigger el8FormLink" data-group="tags">+ Add Another</button></div></div><div class="el8FieldSection clearfix w100 mv5"><p class="mb5"><strong>Document Tags</strong>:</p><ol id="add-doctags-list" class="el8ClearBPM"></ol><div class="el8AlignRight"><button type="button" tabindex="" class="add-entry-trigger el8FormLink" data-group="doctags">+ Add Another</button></div></div><div class="el8FieldSection clearfix w100 mv5"><p class="mb5"><strong>CPT Codes</strong>:</p><ol id="add-cptcodes-list" class="el8ClearBPM"></ol><div class="el8AlignRight"><button type="button" tabindex="" class="add-entry-trigger el8FormLink" data-group="cptcodes">+ Add Another</button></div></div></div><div class="mu-population-buttons"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation.results = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.error) {
    output.append('<p class="el8FeedEmpty">There was an error running the query.</p>');
  } else {
    output.append('<h2 class="el8ReportTitle">Patient List for ', soy.$$escapeHtml(opt_data.panelName), '</h2><div class="mb20"><p class="el8AppText el8Spacer el8ReportFilters">');
    el8.template.appanalytics.reports.muPopulation.filtersAsHtml(opt_data.displayFilters, output);
    output.append('</p><div class="el8ReportActionSection"><button class="send-bulk-letters el8SmallButton mr5 mb5">Send Bulk Patient Letter</button><button class="download-csv el8SmallButton">Download Results as CSV</button></div></div>');
    el8.template.appanalytics.reports.navPanel.content(opt_data, output);
    output.append('<table class="practiceReportTable">');
    if (opt_data.rows.length) {
      output.append('<tr><th class="rowCheckbox"></th>');
      var colList627 = opt_data.cols;
      var colListLen627 = colList627.length;
      for (var colIndex627 = 0; colIndex627 < colListLen627; colIndex627++) {
        var colData627 = colList627[colIndex627];
        output.append('<th>', (colData627.order_by) ? '<a class="sort-trigger" _type="' + soy.$$escapeHtml(colData627.order_by) + '">' + soy.$$escapeHtml(colData627.value) + '<span class="arrow-icon"></span></a>' : soy.$$escapeHtml(colData627.value), '</th>');
      }
      output.append('</tr>');
      var rowList641 = opt_data.rows;
      var rowListLen641 = rowList641.length;
      for (var rowIndex641 = 0; rowIndex641 < rowListLen641; rowIndex641++) {
        var rowData641 = rowList641[rowIndex641];
        output.append('<tr>');
        var cellList643 = rowData641;
        var cellListLen643 = cellList643.length;
        for (var cellIndex643 = 0; cellIndex643 < cellListLen643; cellIndex643++) {
          var cellData643 = cellList643[cellIndex643];
          if (cellData643.patient_id) {
            output.append('<td><input type="checkbox" class="patient-checkbox" data-patient="', soy.$$escapeHtml(cellData643.patient_id), '" /></td><td class="reportIndicatorName"><div class="el8FieldSection">');
            if (cellData643.passport_status) {
              el8.template.appanalytics.reports.muPopulation.passportStatusIcon({status: cellData643.passport_status}, output);
            }
            output.append((cellData643.vip) ? '<span class="padl15"></span><span class="el8VipTag">VIP</span><a target="_blank" rel="noopener" href="/patient/' + soy.$$escapeHtml(cellData643.patient_id) + '/">' + soy.$$escapeHtml(cellData643.value) + '</a>' : '<a target="_blank" rel="noopener" href="/patient/' + soy.$$escapeHtml(cellData643.patient_id) + '/" class="padl15">' + soy.$$escapeHtml(cellData643.value) + '</a>');
            if (cellData643.tag_array.length) {
              output.append('<ol class="padh5">');
              var tagList669 = cellData643.tag_array;
              var tagListLen669 = tagList669.length;
              for (var tagIndex669 = 0; tagIndex669 < tagListLen669; tagIndex669++) {
                var tagData669 = tagList669[tagIndex669];
                output.append('<li class="el8InlineItem el8TagWrap"><span class="el8TagItem el8LabelTagItem">', soy.$$escapeHtml(tagData669), '</span></li>');
              }
              output.append('</ol>');
            }
            output.append('</div></td>');
          } else if (cellData643.age) {
            output.append('<td>', (cellData643.vip) ? '<p class="el8StandardFontSize padb5">hidden</p>' : '<p class="el8StandardFontSize padb5">' + soy.$$escapeHtml(cellData643.value) + '<br/>' + soy.$$escapeHtml(cellData643.age) + '</p>', '</td>');
          } else {
            output.append('<td>', (cellData643.value) ? (cellData643.hcc) ? '<p class="el8StandardFontSize el8HccScore padb5">' + soy.$$escapeHtml(cellData643.value) + '</p>' : '<p class="el8StandardFontSize padb5">' + soy.$$escapeHtml(cellData643.value) + '</p>' : '-', '</td>');
          }
        }
        output.append('</tr>');
      }
    } else {
      output.append('<tr><p class="el8QueueEmpty">There are no patients who match your criteria.</p></tr>');
    }
    output.append('</table>');
    el8.template.appanalytics.reports.navPanel.content(opt_data, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation.passportStatusIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.status == 'NOT_INVITED') ? '<span title="Patient does not have access to Passport" class="passport-no el8PassportIconNo el8PassportIconPatientList"></span>' : (opt_data.status == 'INVITED') ? '<span title="Patient invited but not registered on Passport" class="passport-invited el8PassportIconInvited el8PassportIconPatientList"></span>' : (opt_data.status == 'USED') ? '<span title="Patient has access to Passport" class="passport-yes el8PassportIconYes el8PassportIconPatientList"></span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation.passportStatusInfoText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.status == 'NOT_INVITED') ? 'Patient does not have access to Passport' : (opt_data.status == 'INVITED') ? 'Patient invited but not registered on Passport' : (opt_data.status == 'USED') ? 'Patient has access to Passport' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation.orderStatusInfoText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.status == 'outstanding') ? 'Outstanding' : (opt_data.status == 'cancelled') ? 'Cancelled' : (opt_data.status == 'resolved') ? 'Fulfilled' : (opt_data.status == 'unknown') ? 'Unknown (old orders)' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation.displayOperator = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (opt_data.operator) {
    case 'lt':
      output.append('<');
      break;
    case 'lte':
      output.append('<=');
      break;
    case 'eq':
      output.append('=');
      break;
    case 'gt':
      output.append('>');
      break;
    case 'gte':
      output.append('>=');
      break;
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation.displayLab = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.name), ' ');
  el8.template.appanalytics.reports.muPopulation.displayOperator(opt_data, output);
  output.append(' ', soy.$$escapeHtml(opt_data.value));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation.labTestSelect = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSectionOverflow el8PositionRelative"><div class="el8Wrap el8InlineBlock w40"><select class="w100" name="labTestName_', soy.$$escapeHtml(opt_data.index), '"><option value="">None</option>');
  var lList759 = opt_data.labTests;
  var lListLen759 = lList759.length;
  for (var lIndex759 = 0; lIndex759 < lListLen759; lIndex759++) {
    var lData759 = lList759[lIndex759];
    output.append('<option value="', soy.$$escapeHtml(lData759[0]), '">', soy.$$escapeHtml(lData759[1]), '</option>');
  }
  output.append('</select></div><div class="el8Wrap el8InlineBlock w15"><select class="w100" name="labTestOperator_', soy.$$escapeHtml(opt_data.index), '"><option value="lt">&lt;</option><option value="lte">&le;</option><option value="eq">=</option><option value="gt">&gt;</option><option value="gte">&ge;</option></select></div><div class="el8TextareaWrap el8InlineBlock w25"><input type="text" class="w100" name="labTestValue_', soy.$$escapeHtml(opt_data.index), '" /></div><div class="el8PtListRemoveWrap fr"><a class="remove-entry-trigger el8RemoveAttachmentButton" data-group="labs" data-index="', soy.$$escapeHtml(opt_data.index), '">&times;</a></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation.negatableInput = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSectionOverflow el8PositionRelative"><div class="el8MedToggleContainer el8InlineBlock"><input type="radio" id="');
  el8.template.appanalytics.reports.muPopulation._negatableInputToggleId(soy.$$augmentData(opt_data, {toggleValue: 'false'}), output);
  output.append('" name="');
  el8.template.appanalytics.reports.muPopulation._negatableInputToggleName(opt_data, output);
  output.append('" value="false" class="el8Toggle el8MedToggle el8ToggleTrue" checked /><label for="');
  el8.template.appanalytics.reports.muPopulation._negatableInputToggleId(soy.$$augmentData(opt_data, {toggleValue: 'false'}), output);
  output.append('" class="el8ToggleLabel el8MedToggleLabel el8ToggleLabelOn">Have</label><input type="radio" id="');
  el8.template.appanalytics.reports.muPopulation._negatableInputToggleId(soy.$$augmentData(opt_data, {toggleValue: 'true'}), output);
  output.append('" name="');
  el8.template.appanalytics.reports.muPopulation._negatableInputToggleName(opt_data, output);
  output.append('" value="true" class="el8Toggle el8MedToggle el8ToggleFalse" /><label for="');
  el8.template.appanalytics.reports.muPopulation._negatableInputToggleId(soy.$$augmentData(opt_data, {toggleValue: 'true'}), output);
  output.append('" class="el8ToggleLabel el8MedToggleLabel el8ToggleLabelOff">Don\'t have</label><span class="el8ToggleSelection el8MedToggleSelection"></span></div><div class="el8PtListRemoveWrap fr"><a class="remove-entry-trigger el8RemoveAttachmentButton" data-group="', soy.$$escapeHtml(opt_data.groupName), '" data-index="', soy.$$escapeHtml(opt_data.index), '">&times;</a></div><div class="el8TextareaWrap fr w50"><input type="text" class="w100" name="', soy.$$escapeHtml(opt_data.groupName), '_', soy.$$escapeHtml(opt_data.index), '" /></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation.negatableWithDateRangeInput = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSectionOverflow el8PositionRelative"><div class="el8MedToggleContainer el8InlineBlock"><input type="radio" id="');
  el8.template.appanalytics.reports.muPopulation._negatableInputToggleId(soy.$$augmentData(opt_data, {toggleValue: 'false'}), output);
  output.append('" name="');
  el8.template.appanalytics.reports.muPopulation._negatableInputToggleName(opt_data, output);
  output.append('" value="false" class="el8Toggle el8MedToggle el8ToggleTrue" checked /><label for="');
  el8.template.appanalytics.reports.muPopulation._negatableInputToggleId(soy.$$augmentData(opt_data, {toggleValue: 'false'}), output);
  output.append('" class="el8ToggleLabel el8MedToggleLabel el8ToggleLabelOn">Have</label><input type="radio" id="');
  el8.template.appanalytics.reports.muPopulation._negatableInputToggleId(soy.$$augmentData(opt_data, {toggleValue: 'true'}), output);
  output.append('" name="');
  el8.template.appanalytics.reports.muPopulation._negatableInputToggleName(opt_data, output);
  output.append('" value="true" class="el8Toggle el8MedToggle el8ToggleFalse" /><label for="');
  el8.template.appanalytics.reports.muPopulation._negatableInputToggleId(soy.$$augmentData(opt_data, {toggleValue: 'true'}), output);
  output.append('" class="el8ToggleLabel el8MedToggleLabel el8ToggleLabelOff">Don\'t have</label><span class="el8ToggleSelection el8MedToggleSelection"></span></div><div class="el8PtListRemoveWrap fr"><a class="remove-entry-trigger el8RemoveAttachmentButton" data-group="', soy.$$escapeHtml(opt_data.groupName), '" data-index="', soy.$$escapeHtml(opt_data.index), '">&times;</a></div><div class="el8TextareaWrap fr w50"><input type="text" class="w100" name="', soy.$$escapeHtml(opt_data.groupName), '_', soy.$$escapeHtml(opt_data.index), '" /></div><div class="el8AlignRight fr"><p class="el8InlineBlock">From:</p><div class="el8TextareaWrap el8DatePickerWrap el8InlineBlock el8AlignLeft mtneg2 mb10"><input type="text" class="datePicker dateStart el8DatePickerZindexBoost" name="');
  el8.template.appanalytics.reports.muPopulation._dateRangeStartId(opt_data, output);
  output.append('" id="');
  el8.template.appanalytics.reports.muPopulation._dateRangeStartId(opt_data, output);
  output.append('" data-index="', soy.$$escapeHtml(opt_data.index), '"/></div><p class="el8InlineBlock">To:</p><div class="el8TextareaWrap el8DatePickerWrap el8InlineBlock el8AlignLeft mtneg2 mb10"><input type="text" class="datePicker dateEnd el8DatePickerZindexBoost" name="');
  el8.template.appanalytics.reports.muPopulation._dateRangeEndId(opt_data, output);
  output.append('" id="');
  el8.template.appanalytics.reports.muPopulation._dateRangeEndId(opt_data, output);
  output.append('" data-index="', soy.$$escapeHtml(opt_data.index), '" /></div><div class="el8PtListRemoveWrap fr"></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation._dateRangeStartId = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.groupName), 'StartDate_', soy.$$escapeHtml(opt_data.index));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation._dateRangeEndId = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.groupName), 'EndDate_', soy.$$escapeHtml(opt_data.index));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation._negatableInputToggleId = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.groupName), '-negated-', soy.$$escapeHtml(opt_data.toggleValue), '-', soy.$$escapeHtml(opt_data.index));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation._negatableInputToggleName = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.groupName), 'Negation_', soy.$$escapeHtml(opt_data.index));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation.filtersAsHtml = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.andFilters.hasEntries) {
    output.append('Showing Patients <span class="el8Bold">who meet all of these criteria:</span> ');
    el8.template.appanalytics.reports.muPopulation._filterSection({filterSection: opt_data.andFilters}, output);
  }
  if (opt_data.orFilters.hasEntries) {
    output.append((opt_data.andFilters && opt_data.andFilters.hasEntries) ? ' and <span class="el8Bold">any of these criteria:</span> ' : 'Showing Patients <span class="el8Bold">who meet any of these criteria:</span> ');
    el8.template.appanalytics.reports.muPopulation._filterSection({filterSection: opt_data.orFilters}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation._filterSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appanalytics.reports.muPopulation._filterList({filterList: opt_data.filterSection.positiveList, filterPrefix: 'have'}, output);
  output.append((opt_data.filterSection.positiveList.length && opt_data.filterSection.negativeList.length) ? '; ' : '');
  el8.template.appanalytics.reports.muPopulation._filterList({filterList: opt_data.filterSection.negativeList, filterPrefix: 'don\'t have'}, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.muPopulation._filterList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var filterList881 = opt_data.filterList;
  var filterListLen881 = filterList881.length;
  for (var filterIndex881 = 0; filterIndex881 < filterListLen881; filterIndex881++) {
    var filterData881 = filterList881[filterIndex881];
    output.append((! (filterIndex881 == 0)) ? '; ' : '', (! filterData881.noFilterPrefix) ? soy.$$escapeHtml(opt_data.filterPrefix) + ' ' : '', soy.$$escapeHtml(filterData881.name), ': ');
    var itemList891 = filterData881.list;
    var itemListLen891 = itemList891.length;
    for (var itemIndex891 = 0; itemIndex891 < itemListLen891; itemIndex891++) {
      var itemData891 = itemList891[itemIndex891];
      output.append((! (itemIndex891 == 0)) ? ', ' : '', '\'', soy.$$escapeHtml(itemData891), '\'');
    }
  }
  if (!opt_sb) return output.toString();
};
